export const mimetype = {
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8',
  word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8',
  pdf: 'application/pdf',
};
